module.exports = __webpack_public_path__ + "static/media/bd.d9c4cf32.svg";